import {
  actualizarGrupoInteres,
  crearGrupoInteres,
  eliminarGrupoInteres,
  getGruposInteres,
} from 'api/gruposInteres'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'indicadores'
export function useObtenerGrupoInteres(buscar) {
  return useQuery(key, () => getGruposInteres(buscar))
}

export function useCrearGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(crearGrupoInteres, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(actualizarGrupoInteres, {
    onSuccess: (_, value) => {
      const { id, values: indicadorActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((indicador) => {
          let nuevoGrupoInteres = indicador
          if (id === indicador.id) {
            nuevoGrupoInteres = indicadorActualizado
          }
          return nuevoGrupoInteres
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(eliminarGrupoInteres, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (indicador) => indicador.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useGrupoInteres(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarGrupoInteres } = useEliminarGrupoInteres()
  const { mutateAsync: actualizarGrupoInteres } = useActualizarGrupoInteres()
  const { mutateAsync: crearGrupoInteres } = useCrearGrupoInteres()

  const handleCrearGrupoInteres = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearGrupoInteres(values)
      const message = `El indicador ${data.nombre} fue creado satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarGrupoInteres = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarGrupoInteres({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'El indicador fue actualizado satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarGrupoInteres = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarGrupoInteres(id)
          const message = `El indicador ${data} fue eliminado satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarGrupoInteres = async (value) => {
    queryClient.prefetchQuery(key, () => getGruposInteres(value))
  }

  return {
    obtenerGruposInteres: useObtenerGrupoInteres,
    handleEliminarGrupoInteres,
    handleActualizarGrupoInteres,
    handleCrearGrupoInteres,
    handleBuscarGrupoInteres,
  }
}
